import PropTypes from 'prop-types';
import styled from 'styled-components';

import GameModule from 'src/components/modules/GameModule';
import DetailsModule from 'src/components/modules/DetailsModule';
import GameUploadOptionsModule from 'src/components/modules/GameOptionsModule';
import UtilitiesModule from 'src/components/modules/UtilitiesModule';

export const CenterBlockLayoutWrapper = styled.div`
    display: flex;
    flex: 2 1 0%;
    flex-direction: column;
    gap: 24px;
    order: 2;
`;

function CenterBlockLayout({ showModules }) {
    const renderContent = () => {
        if (showModules) {
            return (
                <>
                    <UtilitiesModule />
                    <DetailsModule />
                </>
            );
        }

        return (
            <GameUploadOptionsModule />
        );
    };

    return (
        <CenterBlockLayoutWrapper>
            <GameModule />
            {renderContent()}
        </CenterBlockLayoutWrapper>
    );
}

export default CenterBlockLayout;

CenterBlockLayout.propTypes = {
    showModules: PropTypes.bool.isRequired,
};
